import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import * as userApi from '@/api/user'
import type { LoginParams, UserInfo } from '@/api/user'
import { getToken, removeToken, setToken } from '@/utils/storage'
// store 内不能用 useRouter()（依赖组件 setup 的 inject），直接引入路由单例
import router from '@/router'
import { useOrderStore } from '@/stores/order'
import { setLoginId } from "@/utils/track"

export const useUserStore = defineStore(
  'user',
  () => {
    const token = ref(getToken() ?? '')
    const userInfo = ref<any>(null)
    const isLogin = computed(() => !!token.value)

    /** 登录并写入 token */
    async function login(params: LoginParams,auth_type = "") {
      let res:any;
      // if(sms){
      //   res = await userApi.loginV3Api(params,auth_type)
      // }else{
      //   res = await userApi.loginV3Api(params,auth_type)
      // }
      res = await userApi.loginV3Api(params,auth_type)
      console.log(res)
      token.value = res.accessToken
      userInfo.value = {
        uid: res.uid,
        unionid: res.authInfo.unionid
      }
      setLoginId(res.uid);
      setToken(res.accessToken)
      return res
    }

    /** 拉取用户信息，已有缓存时直接复用 */
    async function fetchUserInfo(force = false) {
      if (userInfo.value && !force) return userInfo.value
      userInfo.value = await userApi.getUserInfo()
      return userInfo.value
    }

    /** 写入微信授权换取到的 openid（JSAPI 支付需要），合并到现有 userInfo */
    function setOpenid(openid: string) {
      userInfo.value = { ...(userInfo.value || {}), openid }
    }

    /** 清理本地登录态并回登录页（保留当前地址，登录后可回跳） */
    function resetToken() {
      token.value = ''
      userInfo.value = null
      removeToken()
      const currentRoute = router.currentRoute.value
      if (currentRoute.path === '/login') return
      // 跳登录页须将 orderQuery 平铺进 URL query：
      // offline_payment 场景只带 productId 和 orderNo，其余场景带除 orderNo 和 pageFrom 的其他参数
      const orderStore = useOrderStore()
      const { orderNo, pageFrom, ...rest } = orderStore.orderQuery || {}
      const query = pageFrom === 'offline_payment'
        ? { productId: rest.productId, orderNo }
        : { ...rest }
      router.replace({
        path: '/login',
        query
      })
    }

    async function logout() {
      try {
        await userApi.logout()
      } finally {
        resetToken()
      }
    }

    return { token, userInfo, isLogin, login, fetchUserInfo, setOpenid, resetToken, logout }
  },
  {
    // token 由 storage 工具单独维护，此处只持久化用户信息
    persist: { pick: ['userInfo'] },
  },
)
